import { render } from "./ListDetails.vue?vue&type=template&id=2abe0236"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"
script.render = render

export default script